import React from 'react'
import PropTypes from 'prop-types'

export const LoadingIndicator = ({ text }) => {
  return (
    <div className="loadingIndicator">
      <div className="loadingIndicator__background">
        <div className="loadingIndicator__container">
          <div className="loadingIndicator__text">
            {text ?? (
              <>
                Updating
                <br />
                Results
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

LoadingIndicator.propTypes = {
  text: PropTypes.string,
}
